import Vue from "vue";

import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

import {
	getSessionAuto,
	putSessionAuto,
	removeSessionAuto
} from "@/tools/storage";

import user from './modules/user'
import system from './modules/system'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		user,
		system
	},
	plugins: [createPersistedState({
		key: `Vuex`,
		storage: {
			getItem: (key) => getSessionAuto(key),
			setItem: (key, value) => putSessionAuto(key, value),
			removeItem: (key) => removeSessionAuto(key)
		}
	})]
})
